export const enum Bias {
    Negativ = -1,
    Neutral = 0,
    Positiv = 1,
}
